<template>
  <div class="ph-20 mv-12">
    <BlTextAv class="mb-12 qa-txt-title" variation="body-16" weight="medium">Masukkan Nomor Kartu Prakerja</BlTextAv>
    <BlTextfieldAv
      id="prakerja-number-input"
      v-model="form.prakerjaNumber"
      :class="{'border border-crimson-40': errorMessage}"
      class="mb-8 qa-inp-prakerja-number"
      placeholder="Nomor harus sama seperti di kartu"
      @input="sendPayload($event)"
    />
    <BlTextAv v-if="isAutoFill" data-testid="txt-auto-fill">
      <span class="text-green-60">Nomor kartu terisi otomatis dari transaksi sebelumnya.</span>
    </BlTextAv>
    <BlTextAv v-if="errorMessage" class="qa-txt-error-message">
      <span class="text-red-20">{{ errorMessage }}</span>
    </BlTextAv>
  </div>
</template>

<script>
import {BlTextfieldAv} from '@bukalapak/bazaar-mweb-latest';

export default {
  name: 'PrakerjaCheckoutInquiryForm',
  components: {BlTextfieldAv},
  props: {
    errorMessage: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    form: {
      prakerjaNumber: '',
    },
    isAutoFill: false,
  }),
  mounted() {
    this.autoFillPrakerjaNumber();
  },
  methods: {
    sendPayload() {
      const payload = this.form.prakerjaNumber.length >= 10 ? this.form : null;
      this.$emit('onRetrievePayload', payload);
    },
    autoFillPrakerjaNumber() {
      this.$api
        .getPrakerjaLatestTransaction()
        .then(({data}) => {
          if (this.form.prakerjaNumber === '') {
            this.form.prakerjaNumber = data?.customer_number || '';
            this.isAutoFill = true;
          }
        })
        .catch(() => {
          this.form.prakerjaNumber = '';
        });
    },
  },
};
</script>
